import { Link } from "react-router-dom";
import FooterLogo from "../ui/FooterLogo";

const Footer = () => {
  const footerColumns = [
    {
      title: "Om Demenshjältar",
      links: [
        { text: "Hem", href: "/" },
        { text: "Community", href: "/community" },
        { text: "Om oss", href: "/om-oss" },
        { text: "Kampanjer", href: "/kampanjer" },
        { text: "Kontakt", href: "/kontakt" },
      ],
    },
    {
      title: "Bli del av vår community",
      links: [
        { 
          text: "Instagram", 
          href: "https://www.instagram.com/demenshjaltar/", 
          external: true,
          icon: (
            <svg className="w-5 h-5 mr-2 text-minnestig-purple" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.012-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          )
        },
        { 
          text: "Facebook", 
          href: "https://www.facebook.com/groups/demenshjaltar/", 
          external: true,
          icon: (
            <svg className="w-5 h-5 mr-2 text-minnestig-purple" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          )
        },
      ],
    },
    {
      title: "Riktlinjer",
      links: [
        // { text: "Användarvillkor", href: "/documents/anvandarvillkor.pdf", external: true }, // Removed link
        { text: "Integritetspolicy", href: "/integritetspolicy", external: false }, // Updated link to page route
        { text: "Cookiepolicy", href: "/cookiepolicy", external: false }, // Added link to Cookie Policy page
        { text: "Community riktlinjer", href: "/community-riktlinjer", external: false }, // Updated link to page route
      ],
    },
  ];

  return (
    <footer className="bg-minnestig-teal text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2 lg:col-span-1">
            <FooterLogo />
          </div>
          {footerColumns.map((column, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-4">{column.title}</h3>
              <ul className="space-y-2">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-300 hover:text-white transition-colors flex items-center"
                      >
                        {link.icon}
                        {link.text}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        {link.text}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-gray-700 text-center">
          <p className="text-gray-300 text-sm">
            © 2025 MinneStig. Alla rättigheter förbehållna.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
